import styled from 'styled-components';

import { Text } from '@catalyze/ui';

export const StyledText = styled(Text)`
    text-align: center;
    margin-top: 0.5rem;
    color: ${({ theme }) => theme.colors.formLabel};
    font-size: ${({ theme }) => theme.fontSizes[4]};
`;

export const ResetContainer = styled.div`
    display: flex;
    margin-top: 2rem;
`;

export const StyledLabelText = styled(Text)`
    color: ${({ theme }) => theme.colors.formLabel};
`;

export const StyledLinkText = styled(Text)`
    color: ${({ theme }) => theme.colors.badgeFont};
    margin-left: 0.25rem;

    &:hover {
        color: ${({ theme }) => theme.colors.fontSecondary};
    }
`;

export const StyledNavText = styled(Text)`
    margin-right: 1rem;
`;
